import { render, staticRenderFns } from "./EditCampaignList.vue?vue&type=template&id=35bcfffe&scoped=true"
import script from "./EditCampaignList.vue?vue&type=script&lang=js"
export * from "./EditCampaignList.vue?vue&type=script&lang=js"
import style0 from "./EditCampaignList.vue?vue&type=style&index=0&id=35bcfffe&prod&scoped=true&lang=css"
import style1 from "./EditCampaignList.vue?vue&type=style&index=1&id=35bcfffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bcfffe",
  null
  
)

export default component.exports